import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_authenticated/_organization/scheduler/clashes'
)({
  beforeLoad: () => {
    throw redirect({ to: '/scheduler/alerts', search: { tab: 'conflicts' } })
  },
  component: () => null,
})
